import React, { useContext, useState } from 'react';
import { Row, Col } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import {
  InvoiceContext,
  CreateInvoiceFromExcelType,
} from 'views/AccountReceive/common/context/InvoiceContext';
import { FormValues } from 'views/AccountReceive/Routes/Invoice/ModalCreateInvoiceFromExcel/model/formValues.model';
import { useFormContext } from 'react-hook-form';
import { StyledButton, TextHeader, Container } from './Styles';
import ModalConfirm from './ModalConfirm';

const Header: React.FC = () => {
  const { setCreateInvoiceFromExcel } = useContext(InvoiceContext);
  const [openModalConfirm, setOpenModalConfirm] = useState<boolean>(false);

  const { handleSubmit } = useFormContext<FormValues>();

  const onSubmit = handleSubmit(() => {
    setOpenModalConfirm(true);
  });

  return (
    <>
      <Container>
        <Row justify="space-between" align="middle">
          <Col>
            <TextHeader>อัพโหลดไฟล์เอกสาร</TextHeader>
          </Col>
          <Col>
            <StyledButton icon={<CheckCircleOutlined />} color="green" onClick={onSubmit}>
              อัพโหลด
            </StyledButton>
            <StyledButton
              onClick={() => {
                setCreateInvoiceFromExcel(
                  (prevState): CreateInvoiceFromExcelType => ({
                    ...prevState,
                    isOpenModal: false,
                  }),
                );
              }}
            >
              ปิด
            </StyledButton>
          </Col>
        </Row>
        <ModalConfirm visible={openModalConfirm} onCancel={() => setOpenModalConfirm(false)} />
      </Container>
    </>
  );
};

export default Header;
